import { useEffect } from "react";
import type { MicrosoftCallbackMessage } from "./microsoft-popup";

/**
 * Where Microsoft sends "Confirm with Microsoft" back to
 * (`plans/outlook-sync.md`, question 3), and the check before linking a
 * SharePoint folder (`plans/sharepoint-sync.md`). It runs inside the popup, hands the
 * code to the window that opened it, and closes, as Google Drive's callback
 * does: the exchange happens in the opener, which holds the session, and then
 * on the API, which holds the app's secret.
 */
export function MicrosoftCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message: MicrosoftCallbackMessage = {
      source: "gb-microsoft",
      code: params.get("code") ?? undefined,
      state: params.get("state") ?? undefined,
      error: params.get("error") ?? undefined,
    };
    // Our own origin only, never "*": a wildcard would hand the code to
    // whatever page was listening.
    window.opener?.postMessage(message, window.location.origin);
    window.close();
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-canvas px-6 text-center">
      <p className="font-display text-[0.8rem] uppercase tracking-[0.1em] text-muted">
        Finishing the Microsoft sign-in — you can close this window.
      </p>
    </div>
  );
}
